import React from 'react';

const { Consumer, Provider } = React.createContext();

export const ScrollConsumer = Consumer;
export const ScrollProvider = Provider;
